export default "__VITE_ASSET__BUgqxg6N__"